// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2sWXZ","filesListContainer":"PosDisputesFiles_filesListContainer__4_qgN","filesButton":"PosDisputesFiles_filesButton__3lks3"};